import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const ACCIDENT = {
  nickname: 'PRODUCTS.ACCIDENT.nickname',
  properties: [
    // { name: 'wtcAccidentOccupationEducation', key: 'ACCIDENT_OCCUPATION_EDUCATION', group: 'INSURANCE_INFO',
    //   inputType: INPUT_TYPES_CONFIG.STRING,
    //   validator: ['', [
    //     Validators.required
    //   ]]
    // },
    { name: 'wtcAccidentName', key: 'ACCIDENT_NAME', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'clientAge', key: 'ACCIDENT_AGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcAccidentCoverage', key: 'ACCIDENT_COVERAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.FULL_TIME', value: 'FULL_TIME' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.LEISURE_TIME', value: 'LEISURE_TIME' }
        ]
      }
    },
    { name: 'wtcAccidentProgressive', key: 'ACCIDENT_PROGRESSIVE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcAccidentSumInsuredDeath', key: 'ACCIDENT_SUM_INSURED_DEATH', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcAccidentSumInsuredIncapacity', key: 'ACCIDENT_SUM_INSURED_INCAPACITY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required
      ]]
    }
  ],
  lifeInsurance: true,
  icon: 'accident'
};
